import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Router } from '@angular/router';
import { ConstantService } from './constant-service';
import { StorageKeys } from '../Constant/StorageKeys';
import { HttpParams, HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { APIURL } from '../Constant/API_Urls';
import { User } from 'app/Authentification/login-form/user.model';
import { MessageService } from 'primeng/api';


@Injectable(
  {providedIn: 'root'}
)
export class SharedHttpClientService {
  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private constantService: ConstantService,
    private messageService: MessageService,
    ) {
  }

  private attachAuthorization(): any {
    const token = this.addAuthorizationHeaderJWTToken()
    const idToken = this.addAuthorizationHeaderIdToken()
    const options = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'Authorization':token,
        'IdToken':idToken,
      }),
    };

    return options;
  }

  public fileUploadToken(): any {
    const token = this.addAuthorizationHeaderJWTToken()
    const idToken = this.addAuthorizationHeaderIdToken()
    return new HttpHeaders({
        'Authorization':token,
        'IdToken':idToken,
      });
  }

  private attachAuthorizationText(): any {
    const token = this.addAuthorizationHeaderJWTToken()
    const idToken = this.addAuthorizationHeaderIdToken()
    const options : Object = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'Authorization':token,
        'IdToken':idToken,
      }),
      responseType: 'text'
    };
    return options;
  }

  addAuthorizationHeaderJWTToken(): any {
    if (this.isTokenExpired(this.constantService.getSessionStorage(StorageKeys.jwtToken))) {
      return this.constantService.getSessionStorage(StorageKeys.jwtToken);
    }else {
      this.constantService.isSessionExpired = true;
      this.router.navigate(['/login']);
    }
  }

  addAuthorizationHeaderIdToken() {
      return this.constantService.getSessionStorage(StorageKeys.idToken);
  }

  isTokenExpired(token:string) {
    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    let isExpired = (Math.floor((new Date).getTime() / 1000)) >= expiry;
    if(!isExpired){
      return token;
    }else if (isExpired) {
      this.constantService.isSessionExpired = true;
      this.router.navigate(['/login']);
    }
    return token;
  }

  public post(url: string, requestData: any): Observable<any> {
    const options = this.attachAuthorization();
    return this.httpClient.post(url, JSON.stringify(requestData), options);
  }

  public postPlainText(url: string, requestData: any): Observable<any> {
    const options = this.attachAuthorizationText();
    return this.httpClient.post<any>(url, JSON.stringify(requestData),options);
  }

  public get(url: string): Observable<any> {
    const options = this.attachAuthorization();
    
    return this.httpClient.get(url, options);
  }

  public getJson(url: string) {
    return this.httpClient.get(url)
      .pipe(map((response) => {
        return response;      
      })
      );

  }
  public put(url: string, requestData: any) {

    const options = this.attachAuthorization();
    return this.httpClient.put(url, JSON.stringify(requestData), options);
  }

  public delete(url: string) {

    const options = this.attachAuthorization();
    return this.httpClient.delete(url, options);
  }

  httpGetWithParams(url:any, params: HttpParams) {
    let headers = this.fileUploadToken();
    return this.httpClient.get(url, { headers, params, withCredentials: false });//(url, {params: params});
  }

  httpPostWithParams(url:any, searchPayload:any, params: HttpParams) {
    let headers = this.fileUploadToken();
    return this.httpClient.post(url, searchPayload, { headers, params, withCredentials: false });
  }

  refreshToken(user: User): any {
    let headers:any = new Headers();
    headers.append('Content-Type', 'application/json');
     this.httpClient.post(APIURL.mfa_host + APIURL.mfa_login, user, { headers: headers })
    .subscribe(async result => {
      let resultData : any = result;
        let token = resultData.headers.get('Authorization')
       this.constantService.setSessionStorage(StorageKeys.refreshToken, token, 1);
       return this.constantService.getSessionStorage(StorageKeys.refreshToken);
    },
    (err: HttpErrorResponse) => {});
}
}